import { render, staticRenderFns } from "./headOfficeProceedsType.vue?vue&type=template&id=27885669&scoped=true&"
import script from "./headOfficeProceedsType.vue?vue&type=script&lang=js&"
export * from "./headOfficeProceedsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27885669",
  null
  
)

export default component.exports